/**
 * Build an authenticated URL for `/api/files/<storage_path>`.
 *
 * The backend `/api/files/{path}` endpoint requires a bearer token — either
 * via `Authorization: Bearer …` header OR a `?auth=…` query param. HTML tags
 * (`<img src>`, `<video src>`, download `<a href>`, `<iframe>`) can't set
 * request headers, so we must inline the token as a query param.
 *
 * This helper reads the current JWT from localStorage and appends it. If the
 * path is falsy, we return an empty string so callers can safely use the
 * result inside a conditional render.
 *
 * The `?auth=` mechanism was already supported by the backend from day one —
 * we just weren't using it on the frontend, which is why product images broke
 * once we tightened tenant scoping on file downloads.
 */
const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

export function fileUrl(storagePath) {
  if (!storagePath) return '';
  const token = typeof window !== 'undefined' ? localStorage.getItem('token') : null;
  const base = `${BACKEND_URL}/api/files/${storagePath}`;
  return token ? `${base}?auth=${encodeURIComponent(token)}` : base;
}

export default fileUrl;
